import { flatMap, get, has } from "lodash";
import { useReducer } from "react";
import api from "../../apis/axiosInterceptor";

interface Employees {
  employeesData: object;
  totalPageCount: number;
  totalData: number;
  error: string;
}

const initialArgs: Employees = {
  employeesData: {},
  totalPageCount: 0,
  totalData: 17,
  error: "",
};

const reducer = (state: Employees, action: Employees) => {
  return { ...state, ...action };
};

const useEmployees = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getEmployees = async (
    page: string,
    listPerPage: string,
    searchText: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/v1/users/get?role=Employee&page=${page}&listPerPage=${listPerPage}&search=${searchText}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          employeesData: result.data.data.data,
          totalPageCount: get(result, "data.data.totalPageCount", 0),
          totalData: get(result, "data.data.totalData", 0),
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  return {
    getEmployees,
    ...state,
  };
};

export default useEmployees;
